import React from "react";
import ReactCookieConsent from "react-cookie-consent";
import { URLS } from "util/constants";

export default () => {
    if (typeof window !== "undefined") {
        return (
            <ReactCookieConsent
                location="bottom"
                buttonText="Got it!"
                cookieName="GradifiAcceptCookies"
                disableStyles={true}
            >
                <span>This site uses cookies to enhance the user experience. <a href={URLS.MARKETING.PRIVACY_POLICY} target="_blank">Privacy Policy</a></span>
            </ReactCookieConsent>
        );
    }

    return null;
};
